angular.module('impactx.basket').controller('BasketControlsInputCtrl', [
    BasketControlsInputCtrl]);

function BasketControlsInputCtrl() {
    this.keys = ['ctu','ctt','prj','ctrlA','ctrlB','ctrlC','ctrlD','crd','psp','asn','ino','loc','eko','ekg','net','act'];

    this.readOnly = function(aat, controls) {
        if (aat && !aat.readOnly) {
            return false;
        }
        for (var key in controls) {
            if (impactX.isObject(controls[key]) && !controls[key].readOnly) {
                return false;
            }
        }
        return true;
    };
}
